import { render, staticRenderFns } from "./CreateWaveIteration.vue?vue&type=template&id=40a32b26"
import script from "./CreateWaveIteration.vue?vue&type=script&lang=js"
export * from "./CreateWaveIteration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports